import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Spinner,
  UncontrolledTooltip,
  Badge,
} from "reactstrap"
import { useDispatch, useSelector } from "react-redux"

export const LEAD_CONDITION = {
  SUPER_HOT: 'superHot',
  HOT: 'hot',
  WARM: 'warm',
  NORMAL: 'normal',
}

const getDateInputWrapperStyle = ({ isActive, width }) => ({
  minWidth: width || "168px",
  height: "40px",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  padding: "0 12px",
  borderRadius: "10px",
  border: `1px solid ${isActive ? "#2784ff" : "#d9e8ff"}`,
  background: isActive ? "rgba(39, 132, 255, 0.06)" : "#fff",
  boxShadow: isActive ? "0 2px 10px rgba(39, 132, 255, 0.08)" : "none",
  transition: "all 0.2s ease",
})

const dateInputStyle = {
  border: "none",
  outline: "none",
  boxShadow: "none",
  background: "transparent",
  color: "#495057",
  fontSize: "13px",
  fontWeight: 600,
  padding: 0,
  width: "100%",
}

const dateIconStyle = {
  color: "#2784ff",
  fontSize: "16px",
  flexShrink: 0,
}

const clearDateButtonStyle = {
  border: "none",
  background: "rgba(244, 106, 106, 0.12)",
  color: "#f46a6a",
  borderRadius: "999px",
  width: "18px",
  height: "18px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
  cursor: "pointer",
  flexShrink: 0,
  fontSize: "12px",
}

const dateRangeLayoutStyle = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  flexWrap: "wrap",
}

const rangeSeparatorStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  height: "32px",
  minWidth: "32px",
  padding: "0 8px",
  borderRadius: "999px",
  background: "#f4f7ff",
  color: "#6c7a92",
  fontSize: "11px",
  fontWeight: 700,
  textTransform: "uppercase",
}

const getDateRangeToggleStyle = isActive => ({
  width: "40px",
  height: "40px",
  border: `1px solid ${isActive ? "#2784ff" : "#d9e8ff"}`,
  background: isActive ? "#2784ff" : "#fff",
  color: isActive ? "#fff" : "#2784ff",
  borderRadius: "10px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
  cursor: "pointer",
  boxShadow: isActive ? "0 2px 10px rgba(39, 132, 255, 0.14)" : "none",
  transition: "all 0.2s ease",
})

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next"
import { debounce, map, range } from "lodash"
import moment from "moment"

import ToolkitProvider from "react-bootstrap-table2-toolkit"

//actions

import "../../assets/scss/datatables.scss"

import MyPagination from "components/Common/MyPagination"
import DeleteModal from "components/Common/DeleteModal"
import { AvField, AvForm } from "availity-reactstrap-validation"
import InvestmentLeadModal from "./Crud/Modal"
import FollowUpModal from "pages/followUp/Crud/Modal"
import { deleteInvestmentLead, getAllInvestmentLead, getExcelDownloadInvestmentLead } from "store/actions"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { Link } from "react-router-dom"
import ExcelDownload from "hooks/useExcelDownloadButton"

const InvestmentLeadTable = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [page, setPage] = useState(1)
  const [ILModal, setILModal] = useState({ status: false, data: {} })
  const [followUpModal, setFollowUpModal] = useState({ status: false, data: {} })

  const [searchText, setSearchText] = useState("")
  const [totalListLimit, setTotalListLimit] = useState(10)

  const [sort, setSort] = useState("all")
  const [medium, setMedium] = useState("all")
  const [type, setType] = useState("all")
  const [leadCondition, setLeadCondition] = useState("all")
  const [singleDate, setSingleDate] = useState("")
  const [dateRange, setDateRange] = useState({
    from: "",
    to: "",
  })
  const [showDateRange, setShowDateRange] = useState(false)

  const handleMediumValues = value => {
    setMedium(value)
  }
  const handleTypeValues = value => {
    setType(value)
  }
  const handleLeadConditionValues = value => {
    setLeadCondition(value)
  }
  const handleSingleDateChange = value => {
    setSingleDate(value)
    setDateRange({
      from: "",
      to: "",
    })
    setShowDateRange(false)
    setPage(1)
  }
  const handleDateRangeChange = (key, value) => {
    setSingleDate("")
    setShowDateRange(true)
    setDateRange(prev => ({
      ...prev,
      [key]: value,
    }))
    setPage(1)
  }
  const handleClearSingleDate = () => {
    setSingleDate("")
    setPage(1)
  }
  const handleClearDateRange = key => {
    setDateRange(prev => ({
      ...prev,
      [key]: "",
    }))
    setPage(1)
  }
  const toggleDateRange = () => {
    setShowDateRange(prev => !prev)
  }
  const renderDateInput = ({ value, onChange, onClear, placeholder, active, width }) => (
    <div style={getDateInputWrapperStyle({ isActive: active, width })}>
      <i className="bx bx-calendar" style={dateIconStyle} />
      <input
        type="date"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={dateInputStyle}
      />
      {value && (
        <button
          onClick={onClear}
          type="button"
          aria-label="Clear date"
          style={clearDateButtonStyle}
        >
          <i className="bx bx-x" />
        </button>
      )}
    </div>
  )

  const { loading, investmentLeads, allInvestmentLeadsExcel, excelLoading } = useSelector(state => ({
    loading: state.InvestmentLead.loading,
    investmentLeads: state.InvestmentLead.investmentLeads,
    allInvestmentLeadsExcel: state.ExcelDownload?.excelDownloadInvestmentLead?.investmentLeads,
    excelLoading: state.ExcelDownload?.loading,
  }))

  const headers = [
    { label: "No", key: "no" },
    { label: "Date", key: "createdAt" },
    { label: "Name", key: "name" },
    { label: "Phone", key: "phone" },
    { label: "Occupation", key: "occupation" },
    { label: "Place", key: "place" },
    { label: "Medium", key: "medium" },
    { label: "Type", key: "type" },
    { label: "Condition", key: "leadCondition" },
    { label: "Status", key: "status" },
    { label: "Note", key: "note" },
  ]

  const handleExcelDownload = () => {
    dispatch(
      getExcelDownloadInvestmentLead(
        sort === "all" ? "" : sort,
        searchText,
        type === "all" ? "" : type,
        medium === "all" ? "" : medium,
        leadCondition === "all" ? "" : leadCondition,
        singleDate,
        dateRange
      )
    )
  }

  const excelDownloadLeads = map(allInvestmentLeadsExcel, (item, key) => ({
    ...item,
    no: key + 1,
    createdAt: item.createdAt ? moment(item.createdAt).format("DD-MM-YYYY h:mm:A") : "---",
    name: item.name,
    phone: item.phone,
    occupation: item.occupation,
    place: item.place,
    medium: item.medium,
    type: item.type,
    leadCondition: item.leadCondition,
    status: item.status,
    note: item.note,
  }))

  const tableInvestmentLeadData = investmentLeads || {}
  const statusCount = investmentLeads?.counts?.statusCounts || {}
  const mediumCounts = investmentLeads?.counts?.mediumCounts || {}
  const typeCounts = investmentLeads?.counts?.typeCounts || {}
  const leadConditionCounts = investmentLeads?.counts?.leadConditionCounts || {}

  const totalPages = Math.ceil(tableInvestmentLeadData?.total / 10)
  const pages = range(1, totalPages + 1)

  useEffect(() => {
    const filters = {
      sort: sort === "all" ? "" : sort,
      medium: medium === "all" ? "" : medium,
      type: type === "all" ? "" : type,
      leadCondition: leadCondition === "all" ? "" : leadCondition,
      singleDate,
      from: dateRange?.from,
      to: dateRange?.to,
    }
    dispatch(getAllInvestmentLead(page, totalListLimit, searchText, filters))
  }, [dispatch, page, totalListLimit, searchText, sort, medium, type, leadCondition, singleDate, dateRange?.from, dateRange?.to])

  const updatedLocation = {
    ...location,
    state: {
      ...location.state,
      page: 1,
    },
  }

  const [isOpen, setIsOpen] = useState({ status: false, id: "" })

  const handleDelete = id => {
    setIsOpen({ status: true, id: id })
  }

  const handleDeleteEvent = () => {
    dispatch(deleteInvestmentLead(isOpen?.id, setIsOpen))
  }

  const columns = [
    {
      dataField: "no",
      text: "Sl.No",
    },
    {
      dataField: "createdAt",
      text: "Date",
      sort: true,
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
    },

    {
      dataField: "occupation",
      text: "Occupation",
      sort: true,
    },
    {
      dataField: "place",
      text: "Place",
      sort: true,
    },
    {
      dataField: "note",
      text: "Note",
      sort: true,
    },

    {
      dataField: "medium",
      text: "Medium",
      sort: true,
    },
    {
      dataField: "type",
      text: "Type",
      sort: true,
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
    },


    {
      dataField: "action",
      text: "Action",
    },
  ]

  const handleColumns = () => {
    return columns
  }

  const handleStatusColor = key => {
    switch (key) {
      case "new":
        return "primary"
      case "process":
        return "info"
      case "win":
        return "success"
      case "lost":
        return "warning"

      default:
        return ""
    }
  }

  const rowStyle = (row, rowIndex) => {
    const style = { padding: "4px 0" };
    if (row.leadCondition === LEAD_CONDITION.SUPER_HOT) {
      style.borderLeft = '3px solid #f46a6a';
      style.backgroundColor = 'rgba(244, 106, 106, 0.04)';
    } else if (row.leadCondition === LEAD_CONDITION.HOT) {
      style.borderLeft = '3px solid #f1b44c';
      style.backgroundColor = 'rgba(241, 180, 76, 0.04)';
    } else if (row.leadCondition === LEAD_CONDITION.WARM) {
      style.borderLeft = '3px solid #50a5f1';
      style.backgroundColor = 'rgba(80, 165, 241, 0.04)';
    }
    return style;
  };

  const tableData = map(
    tableInvestmentLeadData?.investmentLeads || [],
    (item, index) => ({
      ...item,
      no: (page - 1) * totalListLimit + index + 1,
      name: (
        <>
          <Link to={`/investment-lead-details/${item?._id}`} target="_blank" rel="noreferrer">
            <b style={{ fontSize: "14px", color: "#2784ff", cursor: "pointer" }}>{item?.name}</b>
          </Link>
          <p style={{ fontWeight: 100, color: "gray", margin: 0 }}>{item?.phone}</p>
        </>
      ),

      medium: (
        <>
          <Badge
            style={{ textTransform: "capitalize", marginBottom: "7px" }}
            className={"px-2 py-2 badge-soft-info"}
          >
            {item?.medium === "direct" ? "Walk-In" : item?.medium || "---"}
          </Badge>
        </>
      ),

      type: (
        <>
          <Badge
            style={{ textTransform: "capitalize", marginBottom: "7px" }}
            className={"px-2 py-2 badge-soft-info "}
          >
            {item?.type || "---"}
          </Badge>
        </>
      ),

      status: (
        <>
          <Badge
            style={{ textTransform: "capitalize", marginBottom: "7px" }}
            className={`px-2 py-2 badge-soft-${handleStatusColor(
              item?.status
            )}`}
          >
            {item?.status || "---"}
          </Badge>
        </>
      ),

      createdAt: (
        <>
          <div style={{ width: "100px" }}>
            {item?.createdAt ? moment(item?.createdAt).format("DD-MM-YYYY") : "---"}
          </div>
        </>
      ),

      note: (
        <>
          {item?.note?.length && (
            <UncontrolledTooltip
              placement="bottom"
              target={`note-${item?._id}`}
            >
              {item?.note || ""}
            </UncontrolledTooltip>
          )}
          <div style={{ whiteSpace: "break-spaces" }} id={`note-${item?._id}`}>
            {(item?.note || "").slice(0, 100)}
            {(item?.note || "").length > 100 ? "..." : ""}
          </div>
        </>
      ),

      action: (
        <div>
          <Button
            id={`view${index}`}
            type="button"
            color="white"
            className="ms-1 btn"
            onClick={() => {
              setILModal({ status: true, data: item })
            }}
          >
            <i
              className="bx bx-edit-alt me-2"
              style={{ color: "green", fontSize: "22px" }}
            />
          </Button>
          <>
            <Button
              id={`Delete${index}`}
              type="button"
              color="white"
              className="ms-1 btn "
              onClick={() => {
                handleDelete(item._id)
              }}
            >
              <i
                className="bx bx-trash me-2"
                style={{
                  color: "red",
                  marginBottom: "10px",
                  fontSize: "1.3rem",
                }}
              />
            </Button>
          </>
          <Button
            id={`CreateFollowUp${index}`}
            type="button"
            color="white"
            className="ms-1 btn"
            onClick={() => {
              setFollowUpModal({ status: true, data: { investmentLead: item } })
            }}
          >
            <i
              className="bx bx-task me-2"
              style={{
                color: "orange",
                marginBottom: "10px",
                fontSize: "1.3rem",
              }}
            />
          </Button>
          <UncontrolledTooltip placement="top" target={`CreateFollowUp${index}`}>
            Make followup task
          </UncontrolledTooltip>
        </div >
      ),
    })
  )

  const debounceILSearch = debounce(value => {
    setSearchText(value)
    history.push(updatedLocation)
  }, 600)

  const handlePageLimit = count => {
    setTotalListLimit(count)
  }

  const statusValues = [
    { label: "All", value: "all", count: statusCount?.all },
    { label: "New", value: "new", count: statusCount?.new },
    {
      label: "Process",
      value: "process",
      count: statusCount?.process,
    },
    // {
    //   label: "Processing",
    //   value: "processing",
    //   count: statusCount?.processing,
    // },
    {
      label: "Win",
      value: "win",
      count: statusCount?.win,
    },
    {
      label: "Lost",
      value: "lost",
      count: statusCount?.lost,
    },
  ]

  const listChange = sortValue => {
    setSort(sortValue)
  }

  const MEDIUM_OPTIONS = [
    { label: "All", count: null, value: "all" },
    { label: "Social Media", count: mediumCounts?.social, value: "social" },
    { label: "Walk-In", count: mediumCounts?.direct, value: "direct" },
    { label: "Call", count: mediumCounts?.call, value: "call" },
    { label: "Website", count: mediumCounts?.website, value: "website" },
    { label: "OLX", count: mediumCounts?.olx, value: "olx" },
  ]

  const TYPE_OPTIONS = [
    { label: "All", count: null, value: "all" },
    { label: "Invest", count: typeCounts?.invest, value: "invest" },
    { label: "Franchisee", count: typeCounts?.franchisee, value: "franchisee" },
  ]

  const LEAD_CONDITION_OPTIONS = [
    { label: "All", count: null, value: "all" },
    { label: "Super Hot", count: leadConditionCounts?.superHot, value: LEAD_CONDITION.SUPER_HOT },
    { label: "Hot", count: leadConditionCounts?.hot, value: LEAD_CONDITION.HOT },
    { label: "Warm", count: leadConditionCounts?.warm, value: LEAD_CONDITION.WARM },
    { label: "Normal", count: leadConditionCounts?.normal, value: LEAD_CONDITION.NORMAL },
  ]

  return (
    <React.Fragment>
      <Row>
        <DeleteModal
          show={isOpen?.status}
          onCloseClick={() => setIsOpen({ ...isOpen, status: false })}
          onDeleteClick={handleDeleteEvent}
        />
        {ILModal?.status && (
          <InvestmentLeadModal
            onCloseClick={() => setILModal({ status: false, data: {} })}
            show={ILModal?.status}
            updateData={ILModal?.data}
          />
        )}
        {followUpModal?.status && (
          <FollowUpModal
            onCloseClick={() => setFollowUpModal({ status: false, data: {} })}
            show={followUpModal?.status}
            updateData={followUpModal?.data}
            type="call"
            sort="all"
            task="all"
          />
        )}
        <Col className="col-12">
          <Card>
            <CardBody>
              <ToolkitProvider
                keyField="_id"
                key={"id"}
                columns={handleColumns()}
                data={tableData}
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <div className="d-flex align-items-center justify-center-between ">
                      <div style={{ flex: 1 }}>
                        {map(statusValues, (head, key) => (
                          <>
                            <input
                              type="radio"
                              className="btn-check"
                              name={`btnradio${key}`}
                              id={head?.value}
                              autoComplete="off"
                              checked={sort === head.value}
                              onChange={() => listChange(head?.value)}
                              style={{ display: 'none' }}
                            />
                            <label
                              className="btn w-fit"
                              htmlFor={head?.value}
                              style={{
                                whiteSpace: "nowrap",
                                backgroundColor: sort === head.value ? "#2784ff" : "transparent",
                                borderColor: sort === head.value ? "#2784ff" : "#deebff",
                                color: sort === head.value ? "#fff" : "#333",
                                borderWidth: "1px",
                                borderStyle: "solid",
                                borderRadius: "5px",
                                margin: "2px"
                              }}
                            >
                              {head?.label}
                              <Badge
                                className={`font-size-12 ms-2 ${sort === head.value
                                  ? "badge-soft-light"
                                  : "badge-soft-primary"
                                  }`}
                                pill
                              >
                                {head?.count}
                              </Badge>
                            </label>
                          </>
                        ))}
                      </div>

                      {/* </div> */}
                      <Button
                        type="button"
                        color="warning"
                        className="btn mb-2 me-2"
                        style={{
                          width: "180px",
                        }}
                        onClick={() => setILModal({ status: true })}
                      >
                        <i className="mdi mdi-plus me-1" />
                        New Investment Lead
                      </Button>
                    </div>

                    <div className="d-flex align-items-center justify-content-start p-1 mb-3 flex-wrap gap-4">
                      <div className="">
                        <div className="search-box d-inline-block w-100">
                          <div className="position-relative mx-0">
                            <AvForm>
                              <AvField
                                name="searchText"
                                placeholder="Search"
                                type="text"
                                value={searchText}
                                onChange={e => debounceILSearch(e.target.value)}
                              />
                            </AvForm>
                            <i className="bx bx-search-alt search-icon" />
                          </div>
                        </div>
                      </div>

                      <AvForm
                        className="form-horizontal mx-2 d-flex align-items-center"
                        style={{ minWidth: "120px" }}
                      >
                        <div className="mx-1">
                          <span className="">
                            Show
                            <i className="fas fa-sort-numeric-down-alt mx-1"></i>
                          </span>
                        </div>
                        <div className="" style={{ width: "50px" }}>
                          <AvField
                            name="pageLimit"
                            className="form-control"
                            value={totalListLimit}
                            onChange={e => handlePageLimit(e.target.value)}
                            type="text"
                            required
                          />
                        </div>
                      </AvForm>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          gap: 10,
                          flexWrap: "wrap",
                        }}
                      >
                        <div
                          className="btn-group mt-xl-0 d-flex align-items-center justify-content-start flex-wrap"
                          role="group"
                          aria-label="Basic radio toggle button group"
                        >
                          <label className="mb-2">Medium</label>&nbsp;
                          {map(MEDIUM_OPTIONS, (item, key) => (
                            <div key={key} className="mx-1">
                              <input
                                type="radio"
                                className="btn-check"
                                name="btnradio-medium"
                                id={item.value + "medium"}
                                autoComplete="off"
                                checked={medium === item.value}
                                value={item.value}
                                onChange={e =>
                                  handleMediumValues(e.target.value)
                                }
                              />
                              <label
                                className="btn btn-outline-warning"
                                htmlFor={item.value + "medium"}
                              >
                                {item.label}
                                <Badge
                                  className={`font-size-12 ms-2 ${medium === item.value
                                    ? "badge-soft-white"
                                    : "badge-soft-warning"
                                    }`}
                                  pill
                                >
                                  {item?.count}
                                </Badge>
                              </label>
                            </div>
                          ))}
                        </div>

                        <div
                          className="btn-group d-flex align-items-center justify-content-start flex-wrap"
                          role="group"
                          aria-label="Basic radio toggle button group"
                        >
                          <label className="mb-2">Type</label>&nbsp;
                          {map(TYPE_OPTIONS, (item, key) => (
                            <div key={key} className="mx-1">
                              <input
                                type="radio"
                                className="btn-check"
                                name="btnradio-type"
                                id={item.value + "type"}
                                autoComplete="off"
                                checked={type === item.value}
                                value={item.value}
                                onChange={e => handleTypeValues(e.target.value)}
                              />
                              <label
                                className="btn btn-outline-warning"
                                htmlFor={item.value + "type"}
                              >
                                {item.label}
                                <Badge
                                  className={`font-size-12 ms-2 ${type === item.value
                                    ? "badge-soft-white"
                                    : "badge-soft-warning"
                                    }`}
                                  pill
                                >
                                  {item?.count}
                                </Badge>
                              </label>
                            </div>
                          ))}
                        </div>

                        <div
                          className="btn-group d-flex align-items-center justify-content-start flex-wrap"
                          role="group"
                          aria-label="Basic radio toggle button group"
                        >
                          <label className="mb-2">Condition</label>&nbsp;
                          {map(LEAD_CONDITION_OPTIONS, (item, key) => (
                            <div key={key} className="mx-1">
                              <input
                                type="radio"
                                className="btn-check"
                                name="btnradio-leadCondition"
                                id={item.value + "leadCondition"}
                                autoComplete="off"
                                checked={leadCondition === item.value}
                                value={item.value}
                                onChange={e => handleLeadConditionValues(e.target.value)}
                              />
                              <label
                                className="btn btn-outline-warning"
                                htmlFor={item.value + "leadCondition"}
                              >
                                {item.label}
                                <Badge
                                  className={`font-size-12 ms-2 ${leadCondition === item.value
                                    ? "badge-soft-white"
                                    : "badge-soft-warning"
                                    }`}
                                  pill
                                >
                                  {item?.count}
                                </Badge>
                              </label>
                            </div>
                          ))}
                        </div>

                        <div className="mx-1">
                          <div>
                            {renderDateInput({
                              value: singleDate,
                              onChange: e => handleSingleDateChange(e.target.value),
                              onClear: handleClearSingleDate,
                              placeholder: "Select date",
                              active: Boolean(singleDate),
                              width: "182px",
                            })}
                          </div>
                        </div>

                        <div className="mx-1">
                          <div>
                            <button
                              type="button"
                              onClick={toggleDateRange}
                              style={getDateRangeToggleStyle(showDateRange || Boolean(dateRange?.from || dateRange?.to))}
                              aria-label="Toggle date range"
                              title="Date range"
                            >
                              <i className="bx bx-calendar-event" style={{ fontSize: "16px" }} />
                            </button>
                          </div>
                        </div>

                        {showDateRange && (
                          <div className="mx-1">
                            <div style={dateRangeLayoutStyle}>
                              {renderDateInput({
                                value: dateRange?.from,
                                onChange: e => handleDateRangeChange("from", e.target.value),
                                onClear: () => handleClearDateRange("from"),
                                placeholder: "From",
                                active: Boolean(dateRange?.from),
                                width: "154px",
                              })}
                              <span style={rangeSeparatorStyle}>to</span>
                              {renderDateInput({
                                value: dateRange?.to,
                                onChange: e => handleDateRangeChange("to", e.target.value),
                                onClear: () => handleClearDateRange("to"),
                                placeholder: "To",
                                active: Boolean(dateRange?.to),
                                width: "154px",
                              })}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {loading ? (
                      <Spinner color="secondary" className="d-block m-auto" />
                    ) : (
                      <>
                        {tableInvestmentLeadData?.total >= 1 ? (
                          <>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField={"id"}
                                    key={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    // selectRow={selectRow}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    rowStyle={rowStyle}
                                    {...toolkitProps.baseProps}
                                  // onTableChange={handleTableChange}
                                  // {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <div className="d-flex align-items-center justify-content-between px-4 mt-2">
                              <div className="w-75">
                                <MyPagination
                                  totalPages={pages}
                                  page={page}
                                  setPage={setPage}
                                />
                              </div>
                              <div>
                                {tableInvestmentLeadData?.investmentLeads?.length >= 1 && (
                                  <ExcelDownload
                                    title="Investment Lead Reports"
                                    headers={headers}
                                    excelDownloadData={excelDownloadLeads}
                                    isLoading={excelLoading}
                                    onDownloadClick={handleExcelDownload}
                                  />
                                )}
                              </div>
                            </div>
                          </>
                        ) : (
                          <p className="my-4 mx-3 ">No Leads !</p>
                        )}
                      </>
                    )}
                  </React.Fragment>
                )}
              </ToolkitProvider>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default InvestmentLeadTable
